import React, { useState, useEffect, useRef } from "react";
import {
  AdvSeparator,
  Avatar,
  Backdrop,
  Button,
  DetailCard,
  DropdownMenuNew,
  DualIcon,
  FormFieldSet,
  InfoCircle,
  InfoTextAdv,
  LogoLoader,
  Modal,
  Skeleton,
  SmartTooltip,
  TableAdv,
  showToast,
} from "../../../../components";
import { useDispatch, useSelector } from "react-redux";
import { dateFormator, mapTableRows } from "../../../../utils";
import { Link } from "react-router-dom";
import JobsAccordion from "./JobsAccordion";
import { usePagination } from "../../../../hooks";
import {
  addNoteApi,
  fetchAllNotes,
  fetchAllRecruitersAndBDMUsers,
  fetchAllSubmissions,
  fetchTalentMatch,
  updateJobPostStatus,
  userRefCount,
} from "../../../../redux/slices/bdmjobs/bdmjobsApi";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import {
  fetchAllJobsStart,
  updateBdmJobs,
} from "../../../../redux/slices/bdmjobs/bdmjobsSlice";
import AddJobPost from "../../AccountDetails/AccountDetail/Modals/AddJobPost";
import { convertFromUTC } from "../../../../utils/dateUtils";
import { formatWords2 } from "../../../../utils/stringUtils";

const DraftJobs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [scheduleModal, setScheduleModal] = useState(false);
  const { user } = useSelector((state) => state?.auth);
  const dispatch = useDispatch();
  const jobs = useSelector((state) => state?.bdmJobs?.allJobs?.data);
  const pageLoading = useSelector((state) => state?.bdmJobs?.loading);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  const { value } = useSelector((state) => state?.totalCount);
  const orgId = user?.data?.organizationId.uiid;
  const [allRecruiters, setAllRecruiters] = useState([]);
  const [selectedModalRows, setSelectedModalRows] = useState([]);
  // const totalCount = value || 0;
  const totalCount = value?.allDraftJobsPosts?.data || 0;
  const [loading, setLoading] = useState(false);
  const [noteId, setNoteId] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  const debounceRef = useRef(null);

  // const statusOptions = [
  //   { label: "Active", value: "active" },
  //   { label: "On Hold", value: "on_hold" },
  //   { label: "open", value: "open" },
  // ];
  const recruiterOptions = [
    { label: "Name1", value: "name1" },
    { label: "Name2", value: "name2" },
  ];
  const currencyMap = {
    1: "USD",
    2: "INR",
  };

  const employmentTypeMap = {
    1: "1099",
    2: "C2C",
    3: "C2C",
    4: "Full Time",
    5: "In-cop",
    6: "Intern",
    7: "Other",
    8: "Part Time",
    9: "W-2",
  };

  const toggleAccordion = (rowId, accordionType) => {
    setExpandedRows((prev) => {
      if (prev[rowId] === accordionType) {
        const newState = { ...prev };
        delete newState[rowId];
        return newState;
      }
      return { ...prev, [rowId]: accordionType };
    });
  };

  const formatPayment = (payment) => {
    if (!payment) return "";

    const currency = currencyMap[payment?.currency] || "USD";

    let amount = "";
    if (payment?.amount != null && typeof payment?.amount === "object") {
      amount = `${payment?.amount?.min || ""}-${payment?.amount?.max || ""}`;
    } else if (payment?.amount != null) {
      amount = payment?.amount;
    }

    const freq = payment?.freqType || "";
    const empType = employmentTypeMap[payment?.employmentType] || "";

    return [currency, amount, freq, empType].filter(Boolean).join("/");
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    const optionsDate = { year: "numeric", month: "long", day: "2-digit" };
    const formattedDate = date.toLocaleDateString("en-US", optionsDate);

    const optionsTime = {
      hour: "2-digit",
      minute: "2-digit",
      // second: "2-digit",
      hour12: true,
    };
    const formattedTime = date.toLocaleTimeString("en-US", optionsTime);

    return `${formattedDate} ${formattedTime}`;
  };
  const scheduleInterviewCols = [
    {
      key: "sNo",
      label: "S.No",
    },
    {
      key: "name",
      label: "Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => <div className="text-info-500">{row?.name}</div>,
    },
    {
      key: "email",
      label: "Email ID",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuth",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
  ];
  const scheduleInterviewRows = Array.from({ length: 5 }, (_, index) => ({
    id: index + 1,
    sNo: index + 1,
    name: "Jack Raison",
    email: "jackrai@gmail.com",
    phone: "9876543210",
    jobTitle: "Frontend Developer",
    experience: 3,
    workAuth: "USA",
    location: "Dallas",
  }));

  const mappedScheduleInterviewRows = mapTableRows(
    scheduleInterviewRows,
    scheduleInterviewCols,
  );
  const getSubmissionCounts = (submissions = []) => {
    const counts = { shortlisted: 0, pipeline: 0, submission: 0 };

    (submissions || []).forEach((sub) => {
      const lastStatus =
        sub?.statusHistory?.[sub?.statusHistory?.length - 1]?.status;

      if (lastStatus === 1) counts.shortlisted += 1;
      else if (lastStatus === 2) counts.pipeline += 1;
      else if (lastStatus === 3) counts.submission += 1;
    });

    return counts;
  };

  const onlineStatus = [true, false];
  // const initialJobs = jobs.map((job, index) => ({
  //   id: index,
  //   uiid: job.uiid,
  //   icons: "",
  //   code: job.jobInfo?.jobCode || "",
  //   jobTitle: job.jobId?.title || "",
  //   companyName: job.jobId?.companyId?.name || "N/A",
  //   jobLocation: job.jobInfo?.location
  //     ? `${job.jobInfo.location.city}, ${job.jobInfo.location.state}`
  //     : "N/A",
  //   jobStatus: job.jobId?.status,
  //   contact: Math.floor(Math.random() * 6),
  //   online: onlineStatus[Math.floor(Math.random() * 2)],
  //   applications: job.applicationsCount || 2,
  //   shortlisted: job.shortlistedCount || 0,
  //   pipelined: job.pipelinedCount || 2,
  //   submitted: job.submissions.length || 0,
  //   submissions: job.submissions || [],
  //   clientBill: formatPayment(job.jobInfo?.payments?.billRate),
  //   payBill: formatPayment(job.jobInfo?.payments?.payRate),
  //   deliveryManager: job.assignedTo?.firstName || "-",
  //   jobCreatedBy: job.addedBy?.firstName,
  //   jobCreatedOn: job.addedOn ? formatDateTime(job.jobId.addedOn) : "",
  //   minSalary: job.jobInfo?.payments?.payRate?.amount?.min || "",
  //   maxSalary: job.jobInfo?.payments?.payRate?.amount?.max || "",
  //   notes: job.notes || [],
  //   statusHistory: job.statusHistory || [],
  //   recruiter: job.notifyTo || "-"
  // }));
  const initialJobs = (jobs || []).map((job, index) => {
    const submissionCounts = getSubmissionCounts(job?.submissions || []);

    return {
      id: index,
      uiid: job?.uiid,
      icons: "",
      code: job?.jobInfo?.jobCode || "",
      jobTitle: formatWords2(job?.jobId?.title || ""),
      // companyName: job?.jobId?.companyId?.name || "N/A",
      companyName: job?.jobId?.companyId?.name
        ? formatWords2(job?.jobId?.companyId?.name)
        : "N/A",
      jobLocation: job?.jobInfo?.location
        ? `${job?.jobInfo?.location?.city}, ${job?.jobInfo?.location?.state}`
        : "N/A",
      jobStatus: job?.jobId?.status,
      contact: Math.floor(Math.random() * 6),
      online: onlineStatus[Math.floor(Math.random() * 2)],
      // applications: job.applicationsCount || 2,
      applications: job?.talentMatch?.ids?.length || 0,
      shortlisted: submissionCounts?.shortlisted,
      pipelined: submissionCounts?.pipeline,
      // submitted: submissionCounts?.submission,
      submitted: job?.submissions?.length || 0,
      submissions: job?.submissions || [],
      clientBill: formatPayment(job?.jobInfo?.payments?.billRate),
      payBill: formatPayment(job?.jobInfo?.payments?.payRate),
      deliveryManager: formatWords2(job?.assignedTo?.firstName) || "-",
      jobCreatedBy: formatWords2(job?.addedBy?.firstName),
      jobCreatedOn: job?.addedOn
        ? formatDateTime(convertFromUTC(job?.addedOn))
        : "",
      minSalary: job?.jobInfo?.payments?.payRate?.amount?.min || "",
      maxSalary: job?.jobInfo?.payments?.payRate?.amount?.max || "",
      notes: job?.notes || [],
      statusHistory: job?.statusHistory || [],
      recruiter: job?.notifyTo || "-",
      talentMatchIds: job?.talentMatch?.ids || [],
      canEdit:
        user?.data?.role?.type === 3 && job?.addedBy?.uiid === user?.data?.uiid,
    };
  });
  const [jobStatuses, setJobStatuses] = useState(
    initialJobs.reduce((acc, job) => {
      acc[job.id] = job?.jobStatus;
      return acc;
    }, {}),
  );
  // useEffect(() => {
  //   if (jobs?.length) {
  //     const newStatuses = jobs
  //       .map((job, index) => ({
  //         id: index,
  //         status: job.jobId?.status,
  //       }))
  //       .reduce((acc, job) => {
  //         acc[job.id] = job.status;
  //         return acc;
  //       }, {});

  //     setJobStatuses(newStatuses);
  //   }
  // }, [jobs]);
  const JobPostingStatus = {
    1: "Draft",
    2: "Active",
  };
  const statusOptions = Object.entries(JobPostingStatus).map(
    ([value, label]) => ({
      value: Number(value),
      label,
    }),
  );

  const [recruiter, setRecruiter] = useState(
    initialJobs.reduce((acc, job) => {
      acc[job.id] = job?.recruiter;
      return acc;
    }, {}),
  );

  useEffect(() => {
    if (jobs && jobs.length > 0) {
      const newRecruiterState = jobs.reduce((acc, job) => {
        acc[job.uiid] = job?.notifyTo || [];
        return acc;
      }, {});
      setRecruiter(newRecruiterState);
    }
  }, [jobs]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [showDataId, setShowDataId] = useState([]);
  const [isNotePanelOpen, setIsNotePanelOpen] = useState(false);
  const [showSingleNotes, setShowSingleNotes] = useState(false);
  const [note, setNote] = useState("");
  const [jobPostIds, setJobPostIds] = useState([]);
  const [notes, setNotes] = useState([]);
  const [notesLoading, setNotesLoading] = useState(false);
  const [accordionData, setAccordionData] = useState({});
  const [accordionLoading, setAccordionLoading] = useState({});
  const [selectedJobId, setSelectedJobId] = useState(null);
  const [hoveredNotes, setHoveredNotes] = useState([]);

  const handleSelectionChange = (rows) => {
    setSelectedRows(rows);
    const ids = rows
      .map((rowId) => initialJobs.find((job) => job.id === rowId)?.uiid)
      .filter(Boolean);
    setJobPostIds(ids);
  };

  const getHoveredNotes = async (applicant) => {
    setHoveredNotes([]);
    try {
      setNotesLoading(true);
      const res = await fetchAllNotes({
        coll: "Note",
        pg: 1,
        lim: 2,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: applicant.notes } },
        extret: "uiid firstName",
        sort: { addedOn: -1 },
      });

      if (res?.data) {
        setHoveredNotes(res.data.data || []);
      } else {
        setHoveredNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesLoading(false);
    }
  };

  const colJobDetails = [
    {
      key: "icons",
      label: "",
      width: "min-w-[200px]! max-w-[350px]!",
      render: (row) => {
        const contactEmpty = row?.contact > 0;

        return (
          <div className="flex items-center gap-2">
            <div>
              <DropdownMenuNew
                MenuSection={
                  <div className="flex flex-col">
                    {row?.canEdit && (
                      <Button
                        title={"Edit"}
                        variant="text"
                        color="black"
                        size="xs-sm"
                        className="!justify-start py-2"
                        // onClick={() => setEditModal(true)}
                        onClick={() => {
                          setSelectedJobId(row?.uiid);
                          setEditModal(true);
                        }}
                      />
                    )}
                    <Button
                      title={"Publish"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-1"
                    />
                    <Button
                      title={"Schedule Interview"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setScheduleModal(true)}
                    />

                    <Button
                      title={"Compose Mail"}
                      variant="text"
                      color="black"
                      size="xs-sm"
                      className="!justify-start py-2"
                      onClick={() => setIsModalOpen(true)}
                    />
                  </div>
                }
              >
                <Button
                  icon={"more_vert"}
                  variant="text"
                  type="icon"
                  size="sm"
                  color="black"
                />
              </DropdownMenuNew>
            </div>
            <div>
              <Button
                type="icon"
                icon={"contacts"}
                color={contactEmpty ? "success" : "gray-500"}
                variant="text"
              />
            </div>
            <div
              className={`w-3 h-3 rounded-full ${
                row?.online ? "bg-success" : "bg-gray-200"
              }`}
            ></div>
            <div className="flex items-center gap-2">
              {row?.applications > 0 && (
                // <div
                //   onClick={() => {
                //     toggleAccordion(row.id, "applications");
                //     handleFetchTalentMatch(row);
                //   }}
                // >
                <SmartTooltip description="Talent Match" noicon>
                  <InfoCircle
                    color="invoiced"
                    colorDepth="100"
                    className="text-white"
                    value={row?.applications}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "applications");
                      handleFetchTalentMatch(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}

              {row?.shortlisted > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "shortlisted")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "shortlisted");
                //     handleFetchSubmissions(row, "shortlisted");
                //   }}
                // >
                <SmartTooltip description="Shortlisted" noicon>
                  <InfoCircle
                    className="text-white"
                    value={row?.shortlisted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row.id, "shortlisted");
                      handleFetchSubmissions(row, "shortlisted");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.pipelined > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "pipelined")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "pipelined");
                //     handleFetchSubmissions(row, "pipelined");
                //   }}
                // >
                <SmartTooltip description="Pipeline" noicon>
                  <InfoCircle
                    color="gray"
                    colorDepth="800"
                    className="text-white"
                    value={row?.pipelined}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row?.id, "pipelined");
                      handleFetchSubmissions(row, "pipelined");
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
              {row?.submitted > 0 && (
                // <div
                //   // onClick={() => toggleAccordion(row.id, "submitted")}
                //   onClick={() => {
                //     toggleAccordion(row.id, "submitted");
                //     handleFetchSubmissions(row);
                //   }}
                // >
                <SmartTooltip description="Submission" noicon>
                  <InfoCircle
                    color="info"
                    className="text-white"
                    value={row?.submitted}
                    prefix={"+"}
                    noBorder
                    size="xs"
                    onClick={() => {
                      toggleAccordion(row?.id, "submitted");
                      handleFetchSubmissions(row);
                    }}
                  />
                </SmartTooltip>
                // </div>
              )}
            </div>
            <div
              onMouseEnter={() => getHoveredNotes(row)}
              onMouseLeave={() => setHoveredNotes([])}
            >
              {row?.notes && row.notes.length > 0 && (
                <div>
                  {/* <Button
                        type="icon"
                        icon={"mark_unread_chat_alt"}
                        variant="text"
                        color="warning"
                        onClick={() => {
                          if (!selectedRows.includes(row.id)) {
                            setSelectedRows([...selectedRows, row.id]);
                          }
                          setShowDataId([row.id]);
                          setShowSingleNotes(true);
                        }}
                      /> */}
                  <DualIcon
                    size="sm"
                    badgeIconColor={
                      row?.notes?.length > 0 ? "bg-success" : "bg-dark"
                    }
                    // onClick={() => {
                    //   if (!selectedRows.includes(row.id)) {
                    //     setSelectedRows([...selectedRows, row.id]);
                    //   }
                    //   setShowDataId([row.id]);
                    //   setShowSingleNotes(true);
                    //   setIsNotePanelOpen(false);
                    //   setNoteId(row?.uiid)
                    //   handleFetchNotes(row);
                    // }}
                    onClick={() => {
                      const newSelected = [row.id];
                      setSelectedRows(newSelected);

                      const ids = newSelected
                        .map(
                          (rId) =>
                            initialJobs.find((job) => job.id === rId)?.uiid,
                        )
                        .filter(Boolean);
                      setJobPostIds(ids);

                      setShowDataId([row.id]);

                      setShowSingleNotes(true);
                      setIsNotePanelOpen(false);

                      setNoteId(row?.uiid);

                      handleFetchNotes(row);
                    }}
                    showTooltip={true}
                    tooltipDescription={
                      Array.isArray(hoveredNotes) &&
                      hoveredNotes?.length > 0 ? (
                        <div className="flex flex-col gap-2">
                          {hoveredNotes.map((hoveredNote, i) => (
                            <p key={i}>
                              "{hoveredNote?.note || ""}" by{" "}
                              {formatWords2(hoveredNote?.addedBy?.firstName) ||
                                ""}{" "}
                              on{" "}
                              {dateFormator(
                                convertFromUTC(hoveredNote?.addedOn),
                                "datetime-ampm",
                              ) || ""}
                            </p>
                          ))}
                        </div>
                      ) : (
                        "Add note"
                      )
                    }
                    tooltipDelay={500}
                  />
                </div>
              )}
            </div>
          </div>
        );
      },
    },
    {
      key: "code",
      label: "Job Code",
      width: "min-w-[250px]! max-w-[300px]!",
      render: (row) => (
        // <Link to={`/ats/jobs/job-details`} className="text-info">
        //   {row.code}
        // </Link>
        <Link
          to={`/ats/jobs/job-details`}
          className="text-info"
          state={{ uiid: row.uiid }}
          onClick={() => {
            sessionStorage.setItem("selectedJobUiid", row.uiid);
            sessionStorage.setItem(
              "prevJobsPage",
              window.location.pathname + window.location.search,
            );
          }}
        >
          {row?.code}
        </Link>
        // <Link
        //   to={`/ats/jobs/job-details/${row.uiid}`}
        //   className="text-info"
        // >
        //   {row.code}
        // </Link>
      ),
    },
    {
      key: "jobTitle",
      label: "Job Title",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobTitle}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobTitle}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "companyName",
      label: "Company Name",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.companyName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.companyName}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "jobLocation",
      label: "Job Location",
      // render: (row) => formatWords2(row?.jobLocation),
      render: (row) => (
        <SmartTooltip
          description={formatWords2(row?.jobLocation)}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{formatWords2(row?.jobLocation)}</div>
        </SmartTooltip>
      ),
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobStatus",
      label: "Job Status",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const lastStatus =
          row.statusHistory && row.statusHistory.length > 0
            ? row.statusHistory[row.statusHistory.length - 1].status
            : 2;
        const currentOption =
          statusOptions.find((opt) => opt.value === lastStatus) ||
          statusOptions.find((opt) => opt.value === 2);

        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              type="select"
              noTitle
              size="sm"
              options={statusOptions}
              value={currentOption}
              showSearch
              onChange={(opt) => handleStatusChange(opt, row)}
              // showButton
            />
          </div>
        );
      },
    },

    {
      key: "clientBill",
      label: "Client Bill",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "payBill",
      label: "Pay Bill",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "deliveryManager",
      label: "Delivery Manager",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    // {
    //   key: "recruiter",
    //   label: "Recruiter",
    //   width: 260,
    //   render: (row) => (
    //     <div className="w-[180px] min-w-[160px]">
    //       <FormFieldSet
    //         // type="multiSelect"
    //         type="AllRecruiters"
    //         label="Input"
    //         noTitle
    //         size="sm"
    //         // options={recruiterOptions}
    //         value={row?.recruiter}
    //         // showSearch
    //         // showButton
    //         onChange={(opt) => handleRecruiterChange(opt, row)}
    //       />
    //     </div>
    //   ),
    // },
    {
      key: "recruiter",
      label: "Recruiter",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => {
        const recruiterData = recruiter[row.uiid] || [];
        //  const recruiterOption = recruiterData
        // .filter(r => r && r.uiid)
        // .map(r => ({
        //   label: r.firstName,
        //   value: r.uiid,
        // }));
        const recruiterOption = recruiterData
          .filter((r) => r && r.uiid)
          .map((r) => ({
            label: r.firstName,
            value: `${r.firstName} ${r.lastName}-${r.uiid}`,
          }));

        return (
          <div className="w-[180px] min-w-[160px]">
            <FormFieldSet
              // type="AllRecruiters"
              type="select"
              noTitle
              size="sm"
              multiple
              showSearch
              options={allRecruiters}
              value={recruiterOption}
              onChange={(opt) => handleRecruiterChange(opt, row)}
            />
          </div>
        );
      },
    },
    {
      key: "jobCreatedBy",
      label: "Job Created By",
      width: "min-w-[200px]! max-w-[250px]!",
    },
    {
      key: "jobCreatedOn",
      label: "Job Created On",
      width: "min-w-[200px]! max-w-[250px]!",
      render: (row) => (
        <SmartTooltip
          description={row?.jobCreatedOn}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="line-clamp-1">{row?.jobCreatedOn}</div>
        </SmartTooltip>
      ),
    },
    {
      key: "minSalary",
      label: "Min Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
    {
      key: "maxSalary",
      label: "Max Salary",
      width: "min-w-[150px]! max-w-[200px]!",
    },
  ];

  const rowJobDetails = initialJobs.map((job) => ({
    ...job,
    jobStatus: jobStatuses[job?.id],
  }));

  const mappedRowsJobDetails = mapTableRows(rowJobDetails, colJobDetails);

  const handleDelete = (id) => {
    setShowDataId((data) => data.filter((item) => item !== id));
    setSelectedRows((row) => row.filter((item) => item !== id));
    setJobPostIds((prevIds) => {
      // Find the uiid of the deleted job
      const deletedJob = initialJobs.find((job) => job?.id === id);
      if (deletedJob?.uiid) {
        return prevIds.filter((uiid) => uiid !== deletedJob.uiid);
      }
      return prevIds;
    });
  };

  const rowData = rowJobDetails.filter((item) =>
    selectedRows.includes(item.id),
  );

  const truncateText = (text, limit = 17) => {
    if (!text) return "";
    return text.length > limit ? text.slice(0, limit) + "..." : text;
  };

  const timeCalc = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const weeks = Math.floor(days / 7);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (seconds < 60) return `${seconds}s ago`;
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    if (days < 7) return `${days}d ago`;
    if (weeks < 5) return `${weeks}w ago`;
    if (months < 12) return `${months}mo ago`;
    return `${years}y ago`;
  };

  const handleNoteAdd = async () => {
    if (!note?.trim()) {
      showToast("Note cannot be empty", "error", 2000);
      return;
    }
    // const targetJobIds = showSingleNotes ? showDataId : jobPostIds;
    //  console.log(targetJobIds)
    const targetJobIds = jobPostIds;
    if (!targetJobIds.length) {
      showToast("No job selected", "error", 2000);
      return;
    }
    let notesRes = null;
    try {
      setLoading(true);
      if (targetJobIds.length > 1) {
        let successCount = 0;
        let failCount = 0;
        for (const id of targetJobIds) {
          const res = await addNoteApi({
            coll: "Note",
            postActions: ["updateSource"],
            payload: {
              addedBy: user?.data?.uiid,
              jobPostId: id,
              note,
              source: 1, // 1 for JobPosting
              priority: 3, // low priority by default
            },
          });
          if (res?.data) {
            successCount++;
          } else {
            failCount++;
          }
        }
        if (successCount === 0) {
          showToast("Failed to add notes", "error", 2000);
          return;
        }
        if (failCount > 0) {
          showToast(
            `Added ${successCount} notes, ${failCount} failed`,
            "warning",
            3000,
          );
        }
      }
      // for (const id of jobPostIds) {
      else {
        notesRes = await addNoteApi({
          coll: "Note",
          postActions: ["updateSource"],
          payload: {
            addedBy: user?.data?.uiid,
            jobPostId: targetJobIds[0],
            note,
            source: 1, // 1 for JobPosting
            priority: 3, // low priority by default
          },
        });
        if (!notesRes?.data) {
          showToast("Failed to add note", "error", 2000);
          return;
        }
      }
      //}
      //  console.log(notesRes?.data?.data?.uiid)
      showToast("Note added", "success", 2000);
      setNote("");
      dispatch(
        fetchAllJobsStart({
          coll: "JobPosting",
          lim: limit,
          pg: page,
          // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
          ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
          // ref: "Job Note Submission",
          // ref: "Job",
          ref: "Job Submission",
          extret: "uiid firstName lastName",
          fil: { "statusHistory.status": { type: "NONE", value: 1 } },
          incl: ["", "uiid statusHistory.status"],
          sort: { addedOn: -1 },
        }),
      );
      //if (showSingleNotes && targetJobIds.length === 1) {
      // console.log(jobs)
      if (noteId) {
        const updatedJob = jobs?.find(
          (job) => job.uiid === noteId, //targetJobIds[0]
        );
        //console.log([...updatedJob.notes,noteId])
        if (updatedJob?.notes?.length > 0) {
          const res = await fetchAllNotes({
            coll: "Note",
            ret: "uiid note addedBy addedOn",
            fil: {
              uiid: {
                type: "IN",
                value: [...updatedJob?.notes, notesRes?.data?.data?.uiid],
              },
            },
            extret: "uiid firstName",
          });
          setNotes(res.data?.data || []);
          // console.log(updatedJob.notes )
        } else {
          setNotes([]);
        }
      } else {
        setShowSingleNotes(false);
        setIsNotePanelOpen(false);
      }
    } catch (err) {
      console.error("Error adding note:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchNotes = async (job) => {
    if (!job.notes || job?.notes?.length === 0) {
      showToast("No notes found for this job", "info", 2000);
      return;
    }

    try {
      setNotesLoading(true);
      const res = await fetchAllNotes({
        coll: "Note",
        // pg: 1,
        // lim: 50,
        ret: "uiid note addedBy addedOn",
        fil: { uiid: { type: "IN", value: job?.notes } },
        extret: "uiid firstName",
      });

      // console.log("Fetched Notes:", res.data.data);
      // setNotes(res.data.data || []);
      if (res?.data) {
        setNotes(res?.data?.data || []);
      } else {
        setNotes([]);
      }
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesLoading(false);
    }
  };

  const handleFetchSubmissions = async (job, type = "submitted") => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const submissionIds = (job?.submissions || [])
        .map((sub) => (typeof sub === "object" ? sub?.uiid : sub))
        .filter(Boolean);
      let fil = {
        uiid: { type: "IN", value: submissionIds || [] },
      };
      if (type !== "submitted") {
        fil["statusHistory.status"] = {
          type: "ARRAY_LAST_TWO_FIELDS_EQ",
          value: type === "shortlisted" ? 1 : type === "pipelined" ? 2 : 3,
        };
      }
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: 1,
        lim: 10,
        ref: "JobPosting Candidate",
        // fil: { uiid: { type: "IN", value: job.submissions || [] },"statusHistory.status": {  type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 1 }  },
        // fil: {
        //   uiid: { type: "IN", value: submissionIds || [] },
        //   "statusHistory.status": {
        //     type: "ARRAY_LAST_TWO_FIELDS_EQ",
        //     value: type === "shortlisted" ? 1 : type === "pipelined" ? 2 : 3,
        //   },
        // },
        fil: fil,
        // ret: `uiid submissionStatus addedBy addedOn
        //       candidateId.firstName candidateId.lastName candidateId.mobile
        //       candidateId.source candidateId.skills candidateId.noticePeriod
        //       jobPostId.jobInfo.payments jobPostId.jobInfo.location`,
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRate",
        ],
      });
      if (res?.data) {
        const rows = mapSubmissionsToRows(res?.data?.data || []);
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: rows }));
      }
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };
  const handleFetchTalentMatch = async (job) => {
    try {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: true }));
      const res = await fetchTalentMatch({
        coll: "TalentMatche",
        pg: 1,
        lim: 10,
        ref: "JobPosting Candidate",
        fil: { uiid: { type: "IN", value: job.talentMatchIds || [] } },
        ret: "uiid candidateId jobPostId addedBy addedOn statusHistory",
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location jobInfo.payments.billRate jobInfo.payments.payRate",
          "uiid firstName lastName mobile source resumes currentEmp noticePeriod salaryInfo.payRate",
        ],
      });

      if (res?.data?.data) {
        const structuredRows = mapSubmissionsToRows(res?.data?.data);
        setAccordionData((prev) => ({
          ...prev,
          [job.uiid]: structuredRows,
        }));
      } else {
        showToast("No talent match data found", "info");
        setAccordionData((prev) => ({ ...prev, [job?.uiid]: [] }));
      }
    } catch (err) {
      console.error("❌ Error fetching talent match:", err);
      showToast("Failed to fetch talent match", "error");
    } finally {
      setAccordionLoading((prev) => ({ ...prev, [job?.uiid]: false }));
    }
  };

  const handleStatusChange = async (option, row) => {
    try {
      const newStatus = option;
      const currentStatus =
        row?.statusHistory && row?.statusHistory?.length > 0
          ? row?.statusHistory[row?.statusHistory?.length - 1]?.status
          : 2;
      if (currentStatus === newStatus) {
        showToast("Status already set to this value", "info");
        return;
      }
      const payload = [
        {
          type: "PUSH",
          value: {
            statusHistory: {
              addedBy: user?.data?.uiid,
              addedOn: new Date().toISOString(),
              status: newStatus,
            },
          },
        },
      ];

      const res = await updateJobPostStatus({
        coll: "JobPosting",
        uiid: row?.uiid,
        payload,
      });

      if (res?.data) {
        const updatedJobs = [...jobs];
        const index = updatedJobs.findIndex((job) => job.uiid === row?.uiid);

        if (index !== -1) {
          updatedJobs[index] = {
            ...updatedJobs[index],
            statusHistory: [
              ...(updatedJobs[index].statusHistory || []),
              {
                addedBy: user?.data?.uiid,
                addedOn: new Date().toISOString(),
                status: newStatus,
              },
            ],
          };
        }
        dispatch(updateBdmJobs(updatedJobs));
        showToast("Status updated successfully", "success");
      } else {
        showToast("Failed to update status", "error");
      }
    } catch (err) {
      console.error(err);
      showToast("Failed to update status", "error");
    }
  };

  const extractUiid = (str) => {
    if (!str || typeof str !== "string") return null;

    const parts = str.split("-");
    const last = parts[parts.length - 1];

    const num = Number(last);
    return isNaN(num) ? null : num;
  };

  const handleRecruiterChange = async (newRecruiter, row) => {
    try {
      const normalizedRecruiters = (newRecruiter || []).map((r) => {
        if (typeof r === "object" && r?.value) {
          return r;
        } else {
          const found = allRecruiters.find((opt) => opt.value === r);
          return found || { label: String(r), value: r };
        }
      });

      const uiidList = normalizedRecruiters
        .map((r) => extractUiid(r.value))
        .filter((id) => id !== null);

      const payload = [
        {
          type: "SET",
          value: {
            notifyTo: uiidList,
          },
        },
      ];

      const res = await updateJobPostStatus({
        coll: "JobPosting",
        uiid: row.uiid,
        payload,
      });

      if (res?.data) {
        showToast("Recruiter updated successfully", "success");

        // setRecruiter(prev => ({
        //   ...prev,
        //   [row.uiid]: normalizedRecruiters.map(r => ({
        //     firstName: r?.label,
        //     uiid: r?.value,
        //   })),
        // }));
      } else {
        showToast("Failed to update recruiter", "error");
      }
    } catch (err) {
      console.error("Error updating recruiter:", err);
      showToast("Error updating recruiter", "error");
    }
  };
  const mapSubmissionsToRows = (submissions = []) => {
    return submissions.map((submission) => {
      const candidate = submission?.candidateId || {};
      const job = submission?.jobPostId || {};
      const jobInfo = job?.jobInfo || {};
      const Currency = {
        1: "USD",
        2: "INR",
        3: "CAD",
      };

      return {
        submissionId: submission?.uiid ?? "N/A",
        applicantName:
          `${candidate?.firstName || ""} ${candidate?.lastName || ""}`.trim() ||
          "N/A",
        workAuth: jobInfo?.workAuth?.length
          ? jobInfo?.workAuth.join(", ")
          : "N/A",
        mobile: candidate?.mobile?.primary
          ? `${candidate?.mobile?.primary?.code} ${candidate?.mobile?.primary?.number}`
          : "N/A",
        // location: jobInfo.location
        //   ? `${jobInfo.location.city || ""} - ${jobInfo.location.state || ""}`.trim()
        //   : "N/A",
        jobLocation: job?.jobInfo?.location
          ? [
              job?.jobInfo?.location?.city,
              job?.jobInfo?.location?.state,
              job?.jobInfo?.location?.country,
            ]
              .filter(Boolean)
              .join(", ")
          : "N/A",
        country: jobInfo?.location?.country || "N/A",
        experience: candidate?.exp
          ? `${candidate?.exp?.year || 0}y ${candidate?.exp?.mon || 0}m`
          : "N/A",
        source: candidate?.source || "N/A",
        resume: candidate?.resumes?.length
          ? `Resume (${candidate?.resumes?.length})`
          : "N/A",
        revisionStatus: "Active",
        // applicationStatus: "In Progress", // no status field in submission itself
        applicationStatus: submission?.statusHistory || [], // no status field in submission itself

        // billRate: jobInfo.payments?.billRate?.amount
        //   ? `${jobInfo.payments.billRate.amount}`
        //   : "N/A",
        // payRate: jobInfo.payments?.payRate?.amount
        //   ? `${jobInfo.payments.payRate.amount.min}-${jobInfo.payments.payRate.amount.max}`
        //   : "N/A",
        billRate: jobInfo?.payments?.billRate?.currency
          ? `${Currency[jobInfo?.payments?.billRate?.currency] || "N/A"}-${jobInfo?.payments?.billRate?.amount || "0"}/${jobInfo?.payments?.billRate?.freqType || ""}/${jobInfo?.payments?.billRate?.employmentType || ""}`
          : "N/A",

        payRate: jobInfo?.payments?.payRate?.currency
          ? `${Currency[jobInfo?.payments?.payRate?.currency] || "N/A"}/${jobInfo?.payments?.payRate?.amount?.min || "0"}-${jobInfo?.payments?.payRate?.amount?.max || "0"}/${jobInfo?.payments?.payRate?.freqType || ""}/${jobInfo?.payments?.payRate?.employmentType || ""}`
          : "N/A",

        employerName: candidate?.currentEmp ? "Yes" : "N/A",
        availability: candidate?.noticePeriod?.days === 0 ? "Yes" : "No",
        submittedBy: formatWords2(submission?.addedBy?.firstName || "N/A"),
        pwSubmissionType: submission?.type || "N/A",
        noticePeriod: candidate?.noticePeriod
          ? `${candidate?.noticePeriod?.days} days`
          : "N/A",
        // currentCTC: candidate.salaryInfo?.payRate || "N/A",
        currentCTC: candidate?.salaryInfo?.payRate
          ? (() => {
              const { currency, amount, freqType, employmentType } =
                candidate?.salaryInfo?.payRate;
              const curr = Currency[currency] || "N/A";
              const amt = amount ?? 0;
              const freq =
                freqType?.charAt(0).toUpperCase() + freqType?.slice(1) || "";
              const emp = employmentTypeMap[employmentType] || "";

              let display = `${curr} ${amt}`;
              if (freq) display += ` / ${freq}`;
              if (emp) display += ` / ${emp}`;
              return display.trim();
            })()
          : "N/A",
        submittedOn: submission?.addedOn
          ? formatDateTime(convertFromUTC(submission?.addedOn))
          : "N/A",
        uiid: submission?.uiid || null,
        candidateId: candidate?.uiid || null,
        notes: submission?.notes ?? [],
      };
    });
  };
  const fetchRecruiters = async () => {
    try {
      // dispatch(
      //   totalCountStart({
      //     collection: "users",
      //     coll: "User",
      //     tname: "recruiterCount",
      //     app : "master",
      //     filters : {"role":{"type": "IN", "value":[4]},"organizationId":{"type": "NONE", "value": orgId}},
      //   })
      // );
      // const recruiterCount = value?.recruiterCount?.data || 0;
      // const count = await getTotalCountApi({
      //   collection: "users",
      //   coll: "User",
      //   filters : {"role":{"type": "IN", "value":[1,3,4]},"organizationId":{"type": "NONE", "value": orgId}},
      //   app : "master"
      // })
      const count = await userRefCount({
        fil: JSON.stringify({
          "role.type": { type: "IN", value: [1, 3, 4] },
          status: { type: "NONE", value: 1 },
        }),
      });
      const recruiterCount = count?.data?.data || 0;
      const res = await fetchAllRecruitersAndBDMUsers({
        orgId,
        lim: recruiterCount,
      });

      if (res?.data?.data) {
        const recruiterList = res?.data?.data?.map((r) => ({
          label: `${r?.firstName} ${r?.lastName || ""}`.trim(),
          value: r?.uiid,
        }));
        setAllRecruiters(recruiterList);
      }
    } catch (error) {
      console.error("Failed to fetch recruiters", error);
    }
  };

  const fetchDraftJobs = () => {
    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "allDraftJobsPosts",
        app: "ats",
        filters: { "statusHistory.status": { type: "NONE", value: 1 } },
      }),
    );
    dispatch(
      fetchAllJobsStart({
        coll: "JobPosting",
        lim: limit,
        pg: page,
        // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
        ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
        // ref: "Job Note Submission",
        // ref: "Job",
        ref: "Job Submission",
        extret: "uiid firstName lastName",
        fil: { "statusHistory.status": { type: "NONE", value: 1 } },
        incl: ["", "uiid statusHistory.status"],
        sort: { addedOn: -1 },
      }),
    );
  };

  const fetchDraftJobsSearch = () => {
    dispatch(
      totalCountStart({
        collection: "jobpostings",
        coll: "JobPosting",
        tname: "allDraftJobsPosts",
        app: "ats",
        filters: {
          "statusHistory.status": { type: "NONE", value: 1 },
          "jobInfo.jobCode": { type: "SEARCH", value: searchValue.trim() },
        },
      }),
    );
    dispatch(
      fetchAllJobsStart({
        coll: "JobPosting",
        lim: limit,
        pg: page,
        // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
        ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
        // ref: "Job Note Submission",
        // ref: "Job",
        ref: "Job Submission",
        extret: "uiid firstName lastName",
        fil: {
          "statusHistory.status": { type: "NONE", value: 1 },
          "jobInfo.jobCode": { type: "SEARCH", value: searchValue.trim() },
        },
        incl: ["", "uiid statusHistory.status"],
        sort: { addedOn: -1 },
      }),
    );
  };
  // const selectedRow = initialJobs.find((row) => row.id === expandedRow.id);
  useEffect(() => {
    if (searchValue.trim().length > 1) {
      fetchDraftJobsSearch();
    } else {
      fetchDraftJobs();
    }
    setExpandedRows({});
  }, [dispatch, page, limit]);
  useEffect(() => {
    fetchRecruiters();
  }, []);

  useEffect(() => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }
    if (searchValue.trim().length <= 1) {
      return;
    }
    debounceRef.current = setTimeout(() => {
      fetchDraftJobsSearch();
    }, 500);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, [searchValue]);

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center bg-white/40 backdrop-blur-sm z-50 rounded-lg">
        <LogoLoader />
      </div>
    );
  }

  const handleSubmissionStatusUpdate = async ({
    submissionId,
    candidateId,
    newStatus,
    isTalentMatch,
    type,
  }) => {
    // Update the local accordion data to reflect the change
    setAccordionData((prev) => {
      const updatedData = { ...prev };

      // Find and update the specific row in the accordion data
      Object.keys(updatedData).forEach((jobUiid) => {
        updatedData[jobUiid] = updatedData[jobUiid].map((row) => {
          if (row.submissionId === submissionId) {
            return {
              ...row,
              applicationStatus: [
                ...(row.applicationStatus || []),
                {
                  status: newStatus,
                  addedBy: { uiid: user?.data?.uiid },
                  addedOn: new Date().toISOString(),
                },
              ],
            };
          }
          return row;
        });
      });

      return updatedData;
    });

    // Optionally refetch the jobs data to get updated counts
    // This will refresh the shortlisted/pipelined/submitted counts in the parent table
    // dispatch(
    //   fetchAllJobsStart({
    //     coll: "JobPosting",
    //     lim: limit,
    //     pg: page,
    //     ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
    //     ref: "Job Submission",
    //     fil: { "statusHistory.status": { type: "EXCLUDE", value: 1 } },
    //     extret: "uiid firstName lastName",
    //     incl: ["", "uiid statusHistory.status currentStatus"],
    //     sort: { addedOn: -1 },
    //   })
    // );
  };

  return (
    <div className="flex flex-col mt-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-auto flex gap-4 p-0.5">
        <TableAdv
          showCheckbox
          // singleSelection
          columns={colJobDetails}
          rows={mappedRowsJobDetails}
          defaultSelectedRows={showDataId}
          serverPagination={true}
          totalCount={totalCount}
          page={page}
          expandedRows={expandedRows}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          info={"info"}
          tableId={"DraftJobsTable"}
          serverOnSearch={(key, value) => {
            setSearchValue(value);
            if (!value) {
              fetchDraftJobs();
            }
          }}
          // tdClassName="!py-1"
          // accrodian={({ row, type }) => (
          //   <JobsAccordion row={row} type={type} />
          // )}
          // accrodian={({ row, type }) => {
          //   const submissionRows = accordionData[row.uiid] || [];
          //   return <JobsAccordion rowData={submissionRows} type={type} loading={accordionLoading?.[row.uiid]}/>;
          // }}
          accordion={(row, accordionType) => {
            const submissionRows = accordionData[row.uiid] || [];
            return (
              <JobsAccordion
                rowData={submissionRows}
                type={accordionType}
                loading={accordionLoading?.[row.uiid]}
                onStatusUpdate={handleSubmissionStatusUpdate}
                sourceFrom={"draftJobs"}
              />
            );
          }}
          onSelectionChange={handleSelectionChange}
          toolbarRight={{
            search: true,
            filter: true,
            add: selectedRows.length > 0 && [
              {
                component: (
                  <Button
                    title="Add Note"
                    icon="add"
                    size="sm"
                    onClick={() => {
                      setShowDataId([...selectedRows]);
                      setIsNotePanelOpen(true);
                    }}
                  />
                ),
              },
            ],
          }}
        />

        {/* Notes sidebar stays unchanged */}
        {isNotePanelOpen ? (
          <div className="w-md shadow p-4 overflow-auto flex flex-col gap-5">
            <div className="p-2">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-semibold">Add Notes</h5>
                <Button
                  type="icon"
                  icon={"close"}
                  onClick={() => {
                    setIsNotePanelOpen(false);
                    setShowDataId([]);
                  }}
                  size="xs"
                />
              </div>
              {/* <FormFieldSet type="textArea" rows={5} placeholder="" /> */}
              <FormFieldSet
                type="textArea"
                rows={5}
                placeholder=""
                value={note}
                onChange={(value) => setNote(value)}
              />
            </div>
            <div className="p-2">
              <h6 className="font-semibold mb-2">Selected Jobs</h6>
              {selectedRows.length !== 0 ? (
                rowData.map((row, index) => (
                  <div className="mb-2" key={index}>
                    <DetailCard
                      size="xs"
                      title={
                        <div className="flex items-center gap-4 p-2">
                          <span className="material-symbols-outlined text-primary">
                            business_center
                          </span>
                          <div className="font-bold">
                            <p className="my-1">
                              {formatWords2(row?.jobTitle)}
                            </p>
                            <p className="text-xs text-gray-400">
                              {row?.code || ""}
                            </p>
                          </div>
                        </div>
                      }
                      headeRight={
                        <div>
                          <Button
                            icon={"delete"}
                            variant="text"
                            type="icon"
                            color="black"
                            onClick={() => handleDelete(row?.id)}
                          />
                        </div>
                      }
                    >
                      <AdvSeparator
                        gap="gap-6"
                        className="gap-y-6 overflow-hidden"
                      >
                        {["companyName", "payBill"].map((key, index) => (
                          <div className="p-3" key={index}>
                            <InfoTextAdv
                              title={
                                key === "companyName"
                                  ? "Company Name"
                                  : "Pay Rate"
                              }
                              titleProps={{ className: "!text-black" }}
                              value={
                                <div className="w-full ">
                                  <div className="text-black font-medium ">
                                    <h6 className="truncate whitespace-nowrap overflow-hidden">
                                      {truncateText(row[key])}
                                    </h6>
                                  </div>
                                </div>
                              }
                            />
                          </div>
                        ))}
                      </AdvSeparator>
                    </DetailCard>
                  </div>
                ))
              ) : (
                <p className="text-gray-600 font-md text-md">
                  No Selected Jobs
                </p>
              )}
            </div>
            <div className="mt-auto pt-4 flex justify-center">
              <Button onClick={handleNoteAdd} title="Apply" />
            </div>
          </div>
        ) : showSingleNotes && !isNotePanelOpen ? (
          <div className="w-md shadow p-2 overflow-auto flex flex-col gap-5">
            <div className="p-2">
              <div className="flex justify-between items-center mb-3">
                <h5 className="font-semibold">Add Notes</h5>
                <Button
                  type="icon"
                  icon={"close"}
                  onClick={() => {
                    setShowSingleNotes(false);
                    setSelectedRows((prev) =>
                      prev.filter((id) => !showDataId.includes(id)),
                    );
                    setShowDataId([]);
                  }}
                  size="xs"
                />
              </div>
              <FormFieldSet
                type="textArea"
                rows={5}
                placeholder=""
                value={note}
                onChange={(value) => setNote(value)}
              />
            </div>
            {/* <div className="p-2">
                <h6 className="font-semibold mb-2">Added Notes</h6>
                <div className="my-3">
                  <DetailCard
                    size="xs"
                    title={
                      <div className="flex items-center gap-4 p-2">
                        <Avatar alt={"Ershad Mohammad"} showInitials noBorder />
                        <InfoTextAdv
                          title={"Ershad Mohammad"}
                          titleProps={{
                            className: "!text-black !text-sm  font-[600]",
                          }}
                          value={
                            <p className="line-clamp-1 text-gray font-[600] text-xs">
                              9 hours ago
                            </p>
                          }
                        />
                      </div>
                    }
                    headeRight={
                      <div>
                        <Button
                          icon={"more_vert"}
                          variant="text"
                          type="icon"
                          color="black"
                        />
                      </div>
                    }
                  >
                    <p className="text-sm p-3 ">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    </p>
                  </DetailCard>
                </div>
                <div className="my-3">
                  <DetailCard
                    size="xs"
                    title={
                      <div className="flex items-center gap-4 p-2">
                        <Avatar alt={"Ramesh Manthri"} showInitials noBorder />
                        <InfoTextAdv
                          title={"Ramesh Manthri"}
                          titleProps={{
                            className: "!text-black !text-sm  font-[600]",
                          }}
                          value={
                            <p className="line-clamp-1 text-gray font-[600] text-xs">
                              6 hours ago
                            </p>
                          }
                        />
                      </div>
                    }
                    headeRight={
                      <div>
                        <Button
                          icon={"more_vert"}
                          variant="text"
                          type="icon"
                          color="black"
                        />
                      </div>
                    }
                  >
                    <p className="text-sm p-3 ">
                      Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                    </p>
                  </DetailCard>
                </div>
              </div> */}
            <div className="p-2">
              <h6 className="font-semibold mb-2">Added Notes</h6>

              {/* {rowData[0]?.notes?.length > 0 ? (
                  rowData[0].notes.map((note) => ( */}
              {notesLoading ? (
                <Skeleton variant="paragraph" lines={4} />
              ) : notes?.length > 0 ? (
                (notes || [])
                  .sort((a, b) => new Date(b?.addedOn) - new Date(a?.addedOn))
                  .map((note) => (
                    <div className="my-3" key={note?._id}>
                      <DetailCard
                        size="xs"
                        title={
                          <div className="flex items-center gap-4 p-2">
                            <Avatar
                              alt={`${formatWords2(note?.addedBy?.firstName) || ""}`}
                              showInitials
                              noBorder
                            />
                            <InfoTextAdv
                              title={`${formatWords2(note?.addedBy?.firstName) || ""}`}
                              titleProps={{
                                className: "!text-black !text-sm font-[600]",
                              }}
                              value={
                                <p className="line-clamp-1 text-gray font-[600] text-xs">
                                  {timeCalc(note?.addedOn)}
                                </p>
                              }
                            />
                          </div>
                        }
                        headeRight={
                          <div>
                            <Button
                              icon={"more_vert"}
                              variant="text"
                              type="icon"
                              color="black"
                            />
                          </div>
                        }
                      >
                        <p className="text-sm p-3">{note?.note}</p>
                      </DetailCard>
                    </div>
                  ))
              ) : (
                <p className="text-gray-600 font-md text-md">No Notes Found</p>
              )}
            </div>

            <div className="mt-auto pt-4 flex justify-center">
              <Button onClick={handleNoteAdd} title="Apply" />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <Modal isOpen={isModalOpen} showCloseButton={false} width="max-w-6xl">
        <div>
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Compose Mail"}
            className="!px-0 font-[500]"
            size="xl"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
          <FormFieldSet
            type="select"
            title="Email Source"
            placeholder="Select"
            options={[
              { label: "Gmail", value: 1 },
              { label: "Outlook", value: 2 },
              { label: "Mailgun", value: 3 },
              { label: "AWS-SES", value: 4 },
            ]}
            // value={formData.emailSource}
            // onChange={(value) => handleChange("emailSource", value)}
            // error={errors.emailSource}
          />
          <FormFieldSet
            type="select"
            title="Email Account"
            placeholder="Select Account"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            // value={formData.emailAccount}
            // onChange={(value) => handleChange("emailAccount", value)}
            // error={errors.emailAccount}
          />
          <FormFieldSet
            type="datepicker"
            title="Date Picker"
            placeholder="Select Date"
            // value={formData.datePicker}
            // onChange={(value) => handleChange("datePicker", value)}
            // error={errors.datePicker}
          />
          <FormFieldSet
            type="select"
            title="Template"
            placeholder="Select"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            // value={formData.template}
            // onChange={(value) => handleChange("template", value)}
            // error={errors.template}
          />
          <FormFieldSet
            title="Subject"
            placeholder="Select"
            // value={formData.subject}
            // onChange={(value) => handleChange("subject", value)}
            // error={errors.subject}
          />
        </div>
        <div className="flex flex-col my-4 gap-4">
          <FormFieldSet
            value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
            maxCount={50}
            type="toMailIds"
            title="Include Test Emails Here: 2"
          />
          <FormFieldSet
            type="textArea"
            title="Text Here"
            rows={5}
            placeholder="Enter Text Here"
            // value={formData.emailText}
            // onChange={(value) => handleChange("emailText", value)}
            // error={errors.emailText}
          />
        </div>
        <div className="flex justify-end gap-5 my-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setIsModalOpen(false)}
          />
          <Button title={"Send Email"} />
        </div>
      </Modal>
      <Modal isOpen={scheduleModal} showCloseButton={false} width="max-w-7xl">
        <div className="p-2">
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={"Schedule Interview"}
            className="!px-0 font-[500]"
            size="lg"
            onClick={() => setScheduleModal(false)}
          />
          <TableAdv
            rows={scheduleInterviewRows}
            columns={scheduleInterviewCols}
            showCheckbox
            onSelectionChange={setSelectedModalRows}
            defaultSelectedRows={selectedModalRows}
            tableId={"DraftJobsTable_scheduleinterview"}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: <Button title="Bulk Email" icon="add" size="sm" />,
                },
              ],
            }}
          />
          <div className="flex justify-end my-5">
            <Button
              title={"Cancel"}
              onClick={() => setScheduleModal(false)}
              variant="outlined"
            />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={editModal}
        onClose={() => setEditModal(false)}
        title={"Edit"}
        titleColor={"primary"}
        // width="max-w-4xl"
        width="w-full"
      >
        {/* <EditModal onCancel={() => setOpenEditModal(false)} /> */}
        <AddJobPost
          onCancel={() => setEditModal(false)}
          jobpostId={selectedJobId}
          // onSuccess={() => {
          //   setEditModal(false);
          // }}
          onSuccess={() => {
            setEditModal(false);
            dispatch(
              fetchAllJobsStart({
                coll: "JobPosting",
                lim: limit,
                pg: page,
                // ret: "uiid jobInfo jobId addedOn addedBy statusHistory",
                ret: "uiid jobInfo jobId addedOn addedBy statusHistory notes submissions notifyTo assignedTo talentMatch",
                // ref: "Job Note Submission",
                // ref: "Job",
                ref: "Job Submission",
                extret: "uiid firstName",
                fil: { "statusHistory.status": { type: "NONE", value: 1 } },
                incl: ["", "uiid statusHistory.status"],
                sort: { addedOn: -1 },
              }),
            );
          }}
        />
      </Modal>
      <Backdrop isOpen={pageLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default DraftJobs;
